import * as React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

function PlayIcon({ width = 90, height = 90, color = '#fff', ...otherProps }: Props) {
  return (
    <svg viewBox="0 0 100 100" width={width} height={height} {...otherProps}>
      <defs>
        <filter id="shadow" colorInterpolationFilters="sRGB">
          <feDropShadow dx="2" dy="2" stdDeviation="3" floodOpacity="0.5" />
        </filter>
      </defs>
      <g stroke={color} strokeWidth={3} filter="url(#shadow)">
        <circle cx={50} cy={50} r={40} fill="transparent" />
        <path fill={color} d="M38 30 L70 50 L38 70 L38 30" />
      </g>
    </svg>
  );
}

export default PlayIcon;
